// src/models/constants.ts

/** S3 bucket name for photo storage */
export const S3_BUCKET_NAME = 'myphotos.jamesandellen.com';

/** AWS region for all services */
export const AWS_REGION = 'us-east-1';

/** S3 prefix for full-resolution photos */
export const PHOTOS_PREFIX = 'jaw-all-photos';

/** S3 prefix for thumbnails */
export const THUMBNAILS_PREFIX = 'jaw-all-thumbnails';

/** Pre-signed URL expiry in seconds (60 minutes) */
export const URL_EXPIRY_SECONDS = 3600;

/** Cache name for thumbnails */
export const THUMBNAIL_CACHE_NAME = 'jaw-thumbnails';

/** Cache name for app shell assets */
export const APP_SHELL_CACHE_NAME = 'jaw-app-shell-v1';

/** Maximum cache size in bytes (1 GB) */
export const CACHE_MAX_SIZE_BYTES = 1_073_741_824;

/** Cache staleness threshold in days */
export const CACHE_MAX_AGE_DAYS = 30;

/** Number of photos per page in thumbnail grid */
export const PHOTOS_PER_PAGE = 50;

/** Request timeout in milliseconds */
export const REQUEST_TIMEOUT_MS = 15_000;

/** Maximum number of retry attempts */
export const MAX_RETRIES = 3;

/** Session storage keys for auth tokens */
export const SESSION_STORAGE_KEYS = {
  idToken: 'jaw_id_token',
  accessToken: 'jaw_access_token',
  refreshToken: 'jaw_refresh_token',
  tokenExpiry: 'jaw_token_expiry',
} as const;

/** API Gateway endpoint for access policy operations */
export const API_ENDPOINT = 'https://qcx3f09q0m.execute-api.us-east-1.amazonaws.com/prod';

/** Cognito User Pool ID */
export const COGNITO_USER_POOL_ID = 'us-east-1_9FxON0ZqT';

/** Cognito App Client ID */
export const COGNITO_CLIENT_ID = '34cbefjgchkn7gf62c8eqq8n1e';

/** Cognito Identity Pool ID */
export const COGNITO_IDENTITY_POOL_ID = 'us-east-1:d734cf82-1151-40e1-95a1-ac8b5a6d9cfd';
